/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any */

interface WartoscKredytu {
    kwotaDoDyspozycjiKlienta?: number;
    liczbaRatKredytu?: number;
    prowizjaBanku?: number;
    sumaProcentowSkladek?: number;
    oprocentowanieNominalne?: number;
    kwotaKredytuBruttoVal?: number;
    rataKredytu: number;
    calkowityKosztKredytu?: number;
    prowizjaWartosc?: number;
    ubezpieczenie?: number;
    odsetki?: number;
    rrso: number | string;
}

/**
 * Oblicza oprocentowanie na podstawie okresu spłaty
 *
 * @param okres Okres spłaty

 * @author Jacek Podwysocki
 * @return oprocentowanie
 */
function obliczOprocentowanie(okres: any): number {
    const oprocentowanie = 9.46;

    return oprocentowanie;
}

/**
 * Oblicza prowizję na podstawie okresu spłaty
 *
 * @param okres Okres spłaty

 * @author Jacek Podwysocki
 * @return prowizja
 */
function obliczProwizje(okres: any): number {
    const prowizja = 0;

    return prowizja;
}

function kwotaKredytuBrutto(kwotaDoDyspozycjiKlienta: number, prowizjaBanku: number, sumaProcentowSkladek: number): number {
    const kwotaValue = (kwotaDoDyspozycjiKlienta * 100) / (100 - (prowizjaBanku + sumaProcentowSkladek));

    return parseFloat(kwotaValue.toFixed(2));
}

function rata(kwotaDoDyspozycjiKlienta: number, liczbaRatKredytu: number, kwotaKredytuBruttoVal: number, oprocentowanieNominalne: number): number {
    let rataValue;

    if (oprocentowanieNominalne !== 0) {
        rataValue = (
            (kwotaKredytuBruttoVal * (oprocentowanieNominalne / 1200))
            * Math.pow(1 + (oprocentowanieNominalne / 1200), liczbaRatKredytu)
            / (Math.pow(1 + (oprocentowanieNominalne / 1200), liczbaRatKredytu) - 1)
        );
    } else {
        rataValue = kwotaKredytuBruttoVal / liczbaRatKredytu;
    }

    return parseFloat(rataValue.toFixed(2));
}

export function obliczWartosciKredytu(kwotaDoDyspozycjiKlienta: number, liczbaRatKredytu: number, typUbezpieczenia: number): WartoscKredytu {
    const outputJson: WartoscKredytu = {
        rataKredytu: 0,
        rrso: 0
    };

    let sumaProcentowSkladek;

    // dane wejsciowe wprowadzane przez klienta
    outputJson.kwotaDoDyspozycjiKlienta = kwotaDoDyspozycjiKlienta;
    outputJson.liczbaRatKredytu = liczbaRatKredytu;

    // prowizja przy spłacie przez 6 miesięcy
    const prowizjaBanku = obliczProwizje(liczbaRatKredytu);
    outputJson.prowizjaBanku = prowizjaBanku;

    // 12 - pełne ubezpieczenie, 0 - brak ubezpieczenia
    if (typUbezpieczenia === 1) {
        //sumaProcentowSkladek = 14.45;
        sumaProcentowSkladek = 16.2;

        if (liczbaRatKredytu < 36) {
            sumaProcentowSkladek = 0.45 * liczbaRatKredytu;
        }
    } else {
        sumaProcentowSkladek = 0;
    }

    outputJson.sumaProcentowSkladek = sumaProcentowSkladek;

    // oprocentowanie kredytu
    const oprocentowanieNominalne = obliczOprocentowanie(liczbaRatKredytu);
    outputJson.oprocentowanieNominalne = oprocentowanieNominalne;

    // kwota kredytu
    const kwotaKredytuBruttoVal = kwotaKredytuBrutto(kwotaDoDyspozycjiKlienta, prowizjaBanku, sumaProcentowSkladek);
    outputJson.kwotaKredytuBruttoVal = kwotaKredytuBruttoVal;

    // wartosc raty kredytu
    const rataKredytu = rata(kwotaDoDyspozycjiKlienta, liczbaRatKredytu, kwotaKredytuBruttoVal, oprocentowanieNominalne);
    outputJson.rataKredytu = rataKredytu;

    // wartosc calkowitego kosztu kredytu
    const calkowityKosztKredytu = rataKredytu * liczbaRatKredytu;
    outputJson.calkowityKosztKredytu = Math.round(calkowityKosztKredytu * 100) / 100;

    //prowizja kredytu
    const prowizjaWartosc = (kwotaKredytuBruttoVal * prowizjaBanku) / 100;
    outputJson.prowizjaWartosc = Math.round(prowizjaWartosc * 100) / 100;

    // ubezpieczenie wartosc
    // kwotaKredytuBruttoVal = 15382.64
    const ubezpieczenie = (kwotaKredytuBruttoVal * sumaProcentowSkladek) / 100;
    outputJson.ubezpieczenie = Math.round(ubezpieczenie * 100) / 100;

    // odsetki wartosc
    const odsetki = calkowityKosztKredytu - ubezpieczenie - prowizjaWartosc - kwotaDoDyspozycjiKlienta;
    outputJson.odsetki = Math.round(odsetki * 100) / 100;

    // rrso
    // kwotaDoDyspozycjiKlienta = 12 000
    // liczbaRatKredytu = 60
    const rrso = obliczRrso(kwotaDoDyspozycjiKlienta, liczbaRatKredytu, rataKredytu, liczbaRatKredytu);
    outputJson.rrso = rrso;

    return outputJson;
}

function obliczRrso(wyplata: number, liczbaRat: number, kwotaRaty: number, okresKredytowania: number): number | string {
    const cashflow = [];
    const d = new Date();
    // okresKredytowania = 30;

    let mth = d.getMonth();
    let rok = d.getFullYear();
    let dniSuma = 0;
    let dni = 0, luty, DniWRoku;

    cashflow.push({ period: 0, amount: (-1 * wyplata) });

    for (let i = 1; i <= liczbaRat; i++) {
        if (mth === 12) {
            mth = 0;
            rok = rok + 1;
        } else {
            // mth +=1;
        }

        if (rok % 4 === 0 && rok % 100 !== 0 || rok % 400 === 0) {
            luty = 29;
            DniWRoku = 366;
        } else {
            luty = 28;
            DniWRoku = 365;
        }

        switch (mth) {
            case 0:
                dni = 31;
                break;
            case 1:
                dni = luty;
                break;
            case 2:
                dni = 31;
                break;
            case 3:
                dni = 30;
                break;
            case 4:
                dni = 31;
                break;
            case 5:
                dni = 30;
                break;
            case 6:
                dni = 31;
                break;
            case 7:
                dni = 31;
                break;
            case 8:
                dni = 30;
                break;
            case 9:
                dni = 31;
                break;
            case 10:
                dni = 30;
                break;
            case 11:
                dni = 31;
                break;
        }

        dniSuma += dni;

        cashflow.push({
            period: dniSuma / DniWRoku,
            amount: kwotaRaty
        });

        mth += 1;
    }

    let bestGuess = -1,
        currentNPV;

    for (let rate = 0.00; rate <= 50000; rate += 0.01) {
        let npv = 0;
        // base case

        for (let i = 0; i < cashflow.length; i++) {
            if (typeof cashflow[i].period !== 'number' || typeof cashflow[i].amount !== 'number') {
                throw Error;
            }

            npv += (cashflow[i].amount / Math.pow((1 + rate / 100), cashflow[i].period));
        }

        currentNPV = Math.round(npv * 10) / 10;

        if (currentNPV <= 0) {
            bestGuess = rate - 0.01;

            if (bestGuess === -1 || bestGuess <= 0) {
                return 'N/A';
            }

            return Math.round(bestGuess * 10) / 10;
        }
    }

    if (bestGuess === -1 || bestGuess <= 0) {
        return 'N/A';
    }

    return Math.round(bestGuess * 10) / 10;
}
